import { getToken } from "./isAutenticate";
/*https://twitter.com/i/status/1782803461513359734*/

/*
https://pspdfkit.com/blog/2022/how-to-convert-html-to-pdf-using-react/

*/
import axios from 'axios';


var md5 = getToken;


const serverPrinterconnect = 'https://datacount.com.br/webapi/index.php/';

var url = window.location.host.toLowerCase();

console.log(url)

var serverDatacount = 'https://datacount.com.br/webapi/index.php/';


const token =  md5('printerconnect#2021'); // Defina o token aqui


const Conexao = axios.create({
  baseURL: 'https://datacount.com.br/dataInventory/index.php',
  timeout: 30000,
  headers: {    
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`, // Adiciona o token de autenticação
    'origin' :'*',
    'Referer':'*', 
  }
});
 


  Conexao.interceptors.request.use(async config => {
  const token = md5('printerconnect#2021');//getToken();

  if (token) {
    config.headers.Authorization = 'Bearer '+token;
  }

  return config;

});
export default Conexao;
